/**
 * Ответ сервера на разбиение реплики (translate-python `/metadata_split_subtitle` с
 * `align: "words"` и `keep_translation: true`) — и то, что переводчику нужно о нём знать.
 *
 * Раньше редактор делил окно на равные доли, и переводчик двигал куски руками (37 % разбиений),
 * а перевод родителя уходил в корзину, и те же слова набирались заново. Теперь сервер ставит куски
 * на их слова и режет перевод родителя; здесь — только то, что НЕ получилось: какой кусок не
 * найден в звуке (стоит по доле текста, время надо проверить) и не разрезался ли перевод.
 */

export interface SplitPiecePlacement {
    id: string;
    start: number;
    end: number;
    found: boolean;
}

export interface SplitReport {
    created?: string[];
    placement?: SplitPiecePlacement[];
    method?: "words" | "share";
    words_source?: "folder" | "transcribed" | "none" | null;
    translation?: {
        lang?: string | null;
        method: "model" | "punctuation" | "none";
        parts?: string[];
        error?: string;
    };
}

/** Что сказать переводчику после разбиения; null — всё встало само, говорить нечего. */
export const describeSplit = (report: SplitReport | null | undefined, label: (ms: number) => string): string | null => {
    if (!report) {
        return null;
    }
    const notes: string[] = [];
    const placement = report.placement || [];
    const lost = placement.filter((piece) => !piece.found);
    if (placement.length && lost.length === placement.length) {
        notes.push(
            "слова кусков не найдены в звуке — куски стоят по доле текста в окне реплики, проверьте их время",
        );
    } else if (lost.length) {
        const where = lost.map((piece) => label(piece.start)).join(", ");
        notes.push(
            `${lost.length === 1 ? "кусок" : "куски"} ${where}: слова не найдены в звуке — ` +
                `${lost.length === 1 ? "стоит" : "стоят"} рядом по доле текста, проверьте время`,
        );
    }
    const translation = report.translation;
    if (translation && translation.method === "none" && translation.error) {
        notes.push(`перевод не разрезан по кускам (${translation.error}) — куски переведутся заново`);
    }
    return notes.length ? `Реплика разбита, но ${notes.join("; ")}.` : null;
};
